import { GET_PRODUCT_INFO_SUCCESS } from 'actions/productInfoActions';

export default function productInfo(
	state = {
		ttl: {}
	},
	action = null
) {
	switch (action.type) {
		// TODO: InfiniteScroll breaks if state updates on request
		case GET_PRODUCT_INFO_SUCCESS:
			const ttl = state.ttl || {};
			action.pids.forEach(pid => {
				!ttl[pid] && (ttl[pid] = new Date().getTime() + 1000 * 60);
			});
			return Object.assign({}, state, { ttl }, action.data.productInfo);
		default:
			return state;
	}
}
